import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

AdminGuard.propTypes = {
  children: PropTypes.node,
};

export default function AdminGuard({ children }) {
  const { user } = useAuth();

  if (user && !user.admin) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
}
